// extracted by mini-css-extract-plugin
module.exports = {"dark":"ThemeImage_dark__oVsZD","light":"ThemeImage_light__H9uLQ"};